module.exports = __webpack_public_path__ + "static/gtm_4-94970289f7a19cf6ccdd3afe6b8d6f88.png";